import { createStyles, Theme } from '@zn-material-ui'

export default (theme: Theme) =>
  createStyles({
    accountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      position: 'relative',
      height: 60,
    },
    inputText: {
      paddingLeft: 68,
    },
    name: {
      position: 'absolute',
      bottom: '0px',
      left: '0px',
    },
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'left',
      marginTop: 60,
      backgroundColor: theme.palette.secondary.main,
    },
    textField: {
      width: '460px',
      marginTop: '25px',
      marginBottom: 0,
    },
    identityCode: {
      width: '460px',
    },
    identityCodeLabel: {
      position: 'relative',
      '& .captcha': {
        textAlign: 'right',
        fontSize: 16,
        color: '#4788F3',
        width: 140,
        cursor: 'pointer',
        position: 'absolute',
        right: '0',
        top: '10%',
        transform: 'translateY(-50%)',
      },
    },
    idCodeDisabled: {
      color: 'rgba(65,73,83,0.66)',
    },
    helper: {
      display: 'flex',
      fontSize: 14,
      marginTop: 16,
      position: 'relative',
      paddingLeft: 24,
    },
    agree: {
      color: 'rgba(31,31,31,0.66)',
    },
    znAgreement: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      '&:lang(en)':{
        margin:'0px 5px',
      },
    },
    nextButtonWrapper: {
      marginTop: 50,
    },
    nextButton: {},
    moreAbout: {
      display: 'flex',
      fontSize: 14,
      color: 'rgba(31,31,31,0.66)',
    },
    '@global': {
      '.MuiInputBase-input::placeholder': {
        fontSize: '16px',
      },
    },
  })
